import React from "react";
import pokeball1 from "../assets/pokeball.png";
import pokeball2 from "../assets/pokeball2.png";

const Background = () => {
	return (
		<div className="background">
			<img src={pokeball1} alt="pokeball"  className="pokeball_1" />
			<img src={pokeball2} alt="pokeballs" className="pokeball_2" />
			<img src={pokeball1} alt="pokeball"  className="pokeball_3" />
			<img src={pokeball2} alt="pokeball"  className="pokeball_4" />
			<img src={pokeball1} alt="pokeball"  className="pokeball_5" />
			<img src={pokeball2} alt="pokeball"  className="pokeball_6" />
		</div>
	);
};

export default Background;
